import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { draftFields } from './_shared.js';

/** The story's title screen: a title, an optional subtitle, and the cast lined up behind it. */
export const startActivity: ActivityDefinition = {
  type: 'start_activity',
  summary: 'The story\'s title screen — a title and subtitle, finishing when the player taps Start.',
  setup: z.looseObject({
    ...draftFields,
    title: z.string().optional(),
    subtitle: z.string().optional(),
  }),
};
